import { Fragment } from 'react';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';
import { getColor } from 'common/constants/_colors';
import {
  Flex,
  Separator,
  LegendSymbol
} from 'components/base/layout-components';
import Text from 'components/base/Text';
import { increaseTooltipZIndex } from 'components/Tooltips/helpers';
import CustomPieTooltip from './CustomPieTooltip';
import LegendItem from './LegendItem';
import { PROJECTS } from '../services/projects.services';
import usePmViewer from 'common/hooks/pm/usePmViewer';

const Link = styled(Text)`
  cursor: pointer;
  :hover {
    color: ${getColor('dodgerBlue')};
  }
`;

const InvestmentBreakdownLegend = ({
  investmentDataSorted = [],
  maxTopTypes = 4,
  isLegendHorizontal = true,
  showTitleEllipsisAfter
}) => {
  const isMore = investmentDataSorted.length > parseInt(maxTopTypes);
  const sliceBy = isMore ? maxTopTypes : investmentDataSorted.length;
  const isMoreCount = investmentDataSorted.length - sliceBy;
  const pmViewer = usePmViewer();

  const isMoreTooltip = (
    <Tooltip
      classes={increaseTooltipZIndex()}
      interactive
      placement='bottom'
      title={<CustomPieTooltip data={investmentDataSorted.splice(sliceBy)} />}
    >
      <Link size='small' color={PROJECTS.SECONDARY_COLOR}>
        {isMoreCount} more{' '}
        {isMoreCount > 1
          ? pmViewer.issueType.plural
          : pmViewer.issueType.single}
      </Link>
    </Tooltip>
  );

  return (
    <Flex direction='column'>
      <Flex direction={isLegendHorizontal ? 'row' : 'column'}>
        {investmentDataSorted
          .slice(0, sliceBy)
          .map(({ name, value, color }, idx) => {
            const isLast = sliceBy === parseInt(idx + 1);

            return (
              <Fragment key={idx}>
                <Flex
                  direction='column'
                  data-testid='investment-breakdown-legend-item'
                  {...(idx === 0 || !isLegendHorizontal
                    ? { ml: 'normal' }
                    : {})}
                >
                  {value > 0 && (
                    <LegendItem
                      icon={<LegendSymbol backgroundColor={color} />}
                      sum={value ? `${value}%` : '-'}
                      name={name}
                      isHorizontalView={isLegendHorizontal}
                      showTitleEllipsisAfter={showTitleEllipsisAfter}
                    />
                  )}
                </Flex>
                {!isLast ? (
                  <Separator
                    color={getColor('catskillWhite')}
                    height='unset'
                    margin='0 1.4rem'
                  />
                ) : null}
              </Fragment>
            );
          })}
      </Flex>
      {isMore ? (
        <Flex
          pl='normal'
          {...(isLegendHorizontal && { pt: 'small' })}
          data-testid='investment-breakdown-is-more'
        >
          {isMoreTooltip}
        </Flex>
      ) : null}
    </Flex>
  );
};

export default InvestmentBreakdownLegend;
